const _founded = new Date("2007-02-05");
const _now = new Date();
const _years = _now.getFullYear() - _founded.getFullYear();

export const companyAge =
    _now >= new Date(_now.getFullYear(), _founded.getMonth(), _founded.getDate())
        ? _years
        : _years - 1;